import { default as Select } from 'antd/es/select';
import { default as Space } from 'antd/es/space';
import { useMemo } from 'react';

import { capitalizeFirstLetter } from 'utils/capitalize-first-letter';

import { TertiaryButton } from '@atoms/buttons/TertiaryButton';

import { LocalDateRangeWrapper } from '@molecules/LocalDateRangeWrapper';
import { SelectVirtualAccount } from '@molecules/SelectVirtualAccount';

import {
  STATUS_OPTIONS,
  WITHDRAWALS_ACCOUNT_FILTER_TEST_ID
} from './constants';
import type { FiltersState } from './localState';

const { Option } = Select;

type Props = {
  filters: FiltersState;
  setFilters: (filtersState: FiltersState) => void;
  resetState: () => void;
};

export const WithdrawalFilters = ({
  filters,
  setFilters,
  resetState
}: Props) => {
  const hasFilters = useMemo(() => {
    return Object.values(filters).some(
      (value) => Boolean(value) && value !== 'All'
    );
  }, [filters]);

  return (
    <div className="flex items-center">
      <Space wrap size="small">
        <LocalDateRangeWrapper />

        <SelectVirtualAccount
          onChangeCallback={(value) => {
            setFilters({
              ...filters,
              debtorAccountNumber: value
            });
          }}
          currentAccountNumber={filters.debtorAccountNumber}
          filterCryptoAccounts={true}
          e2eId={WITHDRAWALS_ACCOUNT_FILTER_TEST_ID}
        />

        {/* Status */}
        <Select
          className="mini-cool-shadow w-40"
          showSearch
          value={filters.status}
          popupMatchSelectWidth={false}
          defaultValue="All"
          onChange={(value) => {
            setFilters({
              ...filters,
              status: value
            });
          }}
        >
          <Option key="All">All Statuses</Option>
          {STATUS_OPTIONS.map((option) => (
            <Option key={option} value={option}>
              {capitalizeFirstLetter(option)}
            </Option>
          ))}
        </Select>

        {hasFilters && (
          <TertiaryButton className="h-10 font-semibold" onClick={resetState}>
            Clear filters
          </TertiaryButton>
        )}
      </Space>
    </div>
  );
};
